import { Bell01 } from '@untitledui/icons';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { usePushNotifications } from '@/hooks/usePushNotifications';
import { ButtonList } from '@/lib/base/button-list';
import { Toggle } from '@/lib/base/forms/toggle';

export function NotificationSettings() {
  const isPushNotificationsEnabled = useFeatureFlag('push_notifications');
  const { isSupported, isSubscribed, isLoading, subscribe, unsubscribe } =
    usePushNotifications({
      enabled: isPushNotificationsEnabled,
    });

  if (!isPushNotificationsEnabled || !isSupported) {
    return null;
  }

  const handleToggle = async () => {
    if (isSubscribed) {
      await unsubscribe();
    } else {
      await subscribe();
    }
  };

  return (
    <ButtonList.Item
      trailing={
        <Toggle
          isSelected={isSubscribed}
          onChange={handleToggle}
          isDisabled={isLoading}
          aria-label='Toggle push notifications'
        />
      }
    >
      <div className='flex items-center gap-3'>
        <Bell01 className='w-5 h-5 text-tertiary' />
        <div>
          <p className='font-medium text-primary mb-1'>Push Notifications</p>
          <p className='text-sm text-tertiary'>
            Get notified when new email or calendar proposals need your approval
          </p>
        </div>
      </div>
    </ButtonList.Item>
  );
}
